import React from 'react';
import { AnchorLink, PriceBox } from '..';
import { Grid } from '@mui/material';
import { Title } from '../../atoms';

export const OrderItemList = ({
    quantity,
    size,
    cost,
    text,
    url,
    topText,
    urlTrue
}) => {
    return (
        <div  style={{paddingTop:'0px'}}>
            <Grid container spacing={2}>
                <Grid item md={5} xs={4}>
                <div>
                    <Title text={topText} className="topText" />
                    <AnchorLink
                        text={text}
                        url={url}
                        urlTrue={urlTrue}
                        className={"anchor-url"}
                    />
                </div>
                </Grid>
                <Grid item md={2} xs={2}>
                    <PriceBox textSize="sm" topText={"Quantity"} bottomText={quantity} />
                </Grid>
                <Grid item md={3} xs={4}>
                    <PriceBox textSize="sm" topText={"Size"} bottomText={size}/>
                </Grid>
                <Grid item md={2} xs={2}>
                    <PriceBox  textSize="sm" topText={"Cost"} bottomText={`\u00A3${cost}`} />
                </Grid>
            </Grid>
        </div>
    )
}
